exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".button.is-twitter {\n    background-color: #1da1f2;\n    border-color: #007BCC;\n    color: #fff;\n}\n.button.is-facebook {\n    background-color: #3b5998;\n    border-color: #153372;\n    color: #fff;\n}\n.button.is-google-plus {\n    background-color: #dd4b39;\n    border-color: #B72513;\n    color: #fff;\n}\n.button.is-linkedin {\n    background-color: #0077b5;\n    border-color: #00518F;\n    color: #fff;\n}\n.button.is-reddit {\n    background-color: #5f99cf;\n    border-color: #3973A9;\n    color: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/components/modals/NavButton.css
// module id = 336
// module chunks = 0